import { render, staticRenderFns } from "./TftDetail.vue?vue&type=template&id=353cc13c&"
import script from "./TftDetail.vue?vue&type=script&lang=js&"
export * from "./TftDetail.vue?vue&type=script&lang=js&"
import style0 from "./TftDetail.vue?vue&type=style&index=0&id=353cc13c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports